import { type FC } from "react";

// Markup transcribed from the design port kit (sections/Footer.html), except
// the legal links, which the kit does not carry — keep them across re-exports.
export const SiteFooter: FC = () => (
  <footer>
    <div className="wrap">
      <span>© 2026 Workflow Labs</span>

      <nav className="flinks">
        <a href="/blog">Blog</a>
        <a href="/legal/privacy-policy">Privacy Policy</a>
        <a href="/legal/terms-of-service">Terms of Service</a>
      </nav>
      <span className="fbadge">
        <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <rect
            x="3.25"
            y="7"
            width="9.5"
            height="6.75"
            rx="1.1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.3"
          />
          <path
            d="M5.6 7V5.2a2.4 2.4 0 0 1 4.8 0V7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        </svg>
        HIPAA compliant
      </span>
    </div>
  </footer>
);
